// extracted by mini-css-extract-plugin
export default {"container":"custom-button_container__l01ni","btn":"custom-button_btn__9w6LE","disabled":"custom-button_disabled__inUrt"};